import classNames from "classnames";
import DOMPurify from "dompurify";
import React, { JSX, memo } from "react";

import { ODSBoxProps } from "./ODSBox.types";

const ODSBox = ({
  as: HtmlTag = "div",
  children,
  className,
  visibility = true,
  ...rest
}: ODSBoxProps): JSX.Element | null => {
  let html;
  if (typeof children === "string") {
    const doc = DOMPurify.sanitize(children, { FORCE_BODY: true });
    html = { __html: doc };
  }

  return visibility ? (
    // We pass the sanitised HTML to `dangerouslySetInnerHTML' if it exists
    <HtmlTag
      className={classNames("ODSContainer", className)}
      dangerouslySetInnerHTML={html}
      {...rest}
    >
      {typeof children !== "string" ? children : null}
    </HtmlTag>
  ) : null;
};

ODSBox.displayName = "ODSBox";

export default memo(ODSBox);
